import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDate } from '../../../../utils/fmt';

const TaskListDetails = () => {
    const columns = [
        { label: 'Description', value: 'description' },
        { label: 'Due Date', value: (item) => fmtDate(item.due_date) },
        { label: 'Status', value: 'status' },
        { label: 'Assigned To', value: 'assigned_to_name' },
        { label: 'Related Lead', value: 'related_lead_name' },
        {
            label: 'Access Details',
            value: (taskId) => (
                <button onClick={() => handleAccessDetails(taskId)}>Access Details</button>
            ),
        },
    ];

    const handleAccessDetails = (taskId) => {
        // Handle access details action
        //console.log('Access Details', taskId);
        const encodedId = btoa(taskId);

        window.location.href = `/task/details/${encodedId}`;
    };

    return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES.task} />;
};

export default TaskListDetails;
